import { gql } from '@apollo/client';

export const getSampleRequestConfigurations = gql`
  query getSampleRequestConfigurations {
    sampleRequestConfigurations(filter: { state: { _eq: ACTIVE } }) {
      totalCount
      edges {
        node {
          id
          oid
          name
          title
          sampleRequestDeliveryDateEnabled
          sampleRequestAdditionalDeliveryInformationEnabled
          sampleRequestDeliveryDateMinimumDaysInFuture
        }
      }
    }
  }
`;
